import type { AppProps } from 'next/app'
import '../styles/globals.scss'
import '../styles/homepage.scss'
import '@fontsource/lato/400.css'
import '@fontsource/lato/700.css'
import '@fontsource/lato/900.css'
import '@fontsource-variable/montserrat'
import '@fontsource-variable/inter'
import 'reflect-metadata'
import { AuthProvider } from '../context/auth'
import Head from 'next/head'
import { requestInterceptor, responseInterceptor } from '../utils/interceptor'
import SEO from '../next-seo.config'
import { DefaultSeo } from 'next-seo'

requestInterceptor()
responseInterceptor()
function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <style jsx global>{`
        :root {
          --font-heading: 'Lato';
          --font-body: 'Montserrat Variable';
          --font-sans: 'Inter Variable';
        }
      `}</style>
      <Head>
        <link rel="shortcut icon" href="/favicon.png" />
      </Head>
      <AuthProvider>
        <DefaultSeo {...SEO} />
        <Component {...pageProps} />
      </AuthProvider>
    </>
  )
}

export default MyApp
